import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_post_search_status = _resolveComponent("post-search-status")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.jobRun && _ctx.jobRun.status === 'SUCCESS')
      ? (_openBlock(), _createBlock(_component_q_btn, {
          key: 0,
          label: _ctx.postSearch.numPostsMatched,
          round: "",
          onClick: _ctx.openModal
        }, null, 8, ["label", "onClick"]))
      : (_openBlock(), _createBlock(_component_post_search_status, {
          key: 1,
          "job-id": _ctx.postSearch.job.id,
          "job-run": _ctx.jobRun,
          onChanged: _ctx.onJobRunChange
        }, null, 8, ["job-id", "job-run", "onChanged"]))
  ]))
}